import { Location } from "vue-router";

/** 未ログイン時に会員登録へ直行し、登録後に戻してよいコンテストページ */
const CONTEST_ENTRY_PATH = /^\/event\/contest\/([^/]+)(\/detail)?$/;
/** `/event/contest/:id` と同じ形だが、コンテスト詳細ではない固定ルート */
const NON_CONTEST_SEGMENTS = new Set(["entries", "profile"]);

/**
 * クエリの redirect を、`/event/contest/:id` または `/event/contest/:id/detail` として
 * 安全に使える場合だけ返す。応募履歴・プロフィール・規約・応募フォーム・外部 URL は受け付けない。
 */
export function resolveSafeRedirect(raw: unknown): string | null {
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (typeof value !== "string" || value.length === 0) return null;
  if (!value.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return null;
  const path = value.split(/[?#]/)[0];
  const match = CONTEST_ENTRY_PATH.exec(path);
  if (!match || NON_CONTEST_SEGMENTS.has(match[1])) return null;
  return value;
}

/** 認証画面間のリンクに redirect を引き継ぐ */
export function withRedirect(location: Location, redirect: string | null): Location {
  if (!redirect) return location;
  return { ...location, query: { ...location.query, redirect } };
}
